<template>
  <div class="snsRegister">
    <button
    class="btn snsRegister__line"
    type="button"
    data-color="sns_line"
    @click="clickLine"
    v-if="hiddenData!='twitter'">
      <img src="/static/img/common/sns_icon_line.svg" width="25" />
      LINEで{{option.linkText}}
    </button>
    <button
      class="btn snsRegister__twitter"
      type="button"
      data-color="sns_twitter"
      @click="registrationWithTwitter"
      v-if="hiddenData!='line'">
      <img src="/static/img/common/sns_icon_twitter.svg" width="17" />
      Twitterで{{option.linkText}}
    </button>
    <BaseModal
      v-if="isShowLineModal"
      :bg-close="true"
      :is-show-confirm="false"
      @close="isShowLineModal = !isShowLineModal">
      <div class="lineModal">
        <h2>LINEログインに関して</h2>
        <p class="lineModal__body">
          サイトリニューアルに伴い2020/4/30以前にLINEでアカウント登録された方は、運営の都合上登録を解除いたしました。<br>ご利用いただくには再度アカウント登録をお願します。
        </p>
        <p class="lineModal__attention">
          ※過去に購入した商品は、購入完了メール・納品メールに記載されているURLからご確認いただけます。
        </p>
        <a
          class="btn snsRegister__line lineModal__button"
          href="https://us-central1-agarustore.cloudfunctions.net/generateLineLoginUri?registration=1"
          data-color="sns_line"
          @click="showLineModal">
          <img src="/static/img/common/sns_icon_line.svg" width="25" />
            LINEで登録
        </a>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import login from './login'
import BaseModal from './common/BaseModal'
export default {
  name: 'sns-register',
  mixins: [login],
  components:{
    BaseModal
  },
  props: {
    registToken: String,
    registerType: { type: String, default: 'signup' },
    hiddenRelation: { type: String, default: '' }
  },
  computed: {
    ...mapState({
      authUser: state => state.auth.data
    })
  },
  data() {
    return {
      cpno: window.Laravel.cpno,
      token: window.Laravel.csrfToken,
      option: {
        lineUrl: 'https://us-central1-agarustore.cloudfunctions.net/generateLineLoginUri?registration=1',
        linkText: '登録'
      },
      hiddenData: '',
      disabledData: '',
      isShowLineModal: false
    }
  },
  mounted() {
    if(this.registerType=='signin'){
      this.option.lineUrl = 'https://us-central1-agarustore.cloudfunctions.net/generateLineLoginUri'
      this.option.linkText = 'ログイン'
    }
    this.hiddenData = this.getHiddenRelationData()
    this.disabledData = this.getDisabledRelationData()
  },
  methods: {
    registrationWithTwitter() {
      const provider = new firebase.auth.TwitterAuthProvider();
      firebase.auth().signInWithPopup(provider)
      .catch(error => alert(error.message))
      .then(result => {
        const data = {
          nickname: result.user.displayName,
          email: result.user.providerData[0].email,
          uid: result.user.uid,
          sns: 'twitter',
          cpno: this.cpno
        }
        this.registrationByFirebaseUid(data)
      })
    },
    getHiddenRelationData() {
      if(!!this.authUser && this.authUser.is_registed && this.authUser.relation!='' && this.registerType=='signin'){
        return this.authUser.relation
      }
      return ''
    },
    getDisabledRelationData() {
      if(!!this.authUser && this.authUser.is_registed && this.authUser.relation!='' && this.registerType=='signup'){
        return this.authUser.relation
      }
      return ''
    },
    clickLine(){
      if (this.registerType === 'signin') this.isShowLineModal = true
      else location.href = this.option.lineUrl
    }
  }
}</script>

<style lang="scss">
.snsRegister{
  display: flex;
  justify-content: center;

  &__line,&__twitter{
    border-radius: 5px;
    flex: 1 1 auto;
    max-width: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    img{
      margin-right: 10px;
    }
  }
  &__line {
    img {
      margin-left: -4px;
    }
  }
  &__twitter{
    margin-left: 10px;
  }
}

.lineModal{
    h2{
      text-align: center;
      font-size: 26px;
      margin-top: 0;
    }
    &__body{
      font-size: 13px;
      line-height: 19px;
      text-align: justify;
    }
    &__attention{
      font-size: 11px;
      line-height: 16px;
      text-align: justify;
      margin-bottom: 32px;
    }
    &__login{
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      font-weight: bold;
    }

    &__button{
      margin: 0 auto 24px;
      width: 152px;
    }
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SnsRegister.vue